import { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Permissions } from "../../../util/Permissions";
import Actions from "./actions/Actions";
import Admins from "./admins/Admins";
import Settings from "./settings/Settings";
import Migrations from "../../Migration/pages";
import BankManagement from "../../BankManagement/pages";
import { Section } from "../../Common/layout/Section";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Permission } from "../../Common/layout/Permission";
import Overview from "./overiew/Overview";
import SafeLockManagement from "../../SafeLockManagement/pages";
import Plans from "./plans/Plans";
import Balance from "./balance/Balance";

export default function OverviewPages() {
    return (
        <>
            <AsideMenu>
                <AsideMenu.NavItem to={"/overview"} exact>
                    Overview
                </AsideMenu.NavItem>
                <Permission permission={"admins"}>
                    <AsideMenu.NavItem to={"/overview/admins"}>
                        Admins
                    </AsideMenu.NavItem>
                </Permission>
                <Permission permission={Permissions.ACTIONS}>
                    <AsideMenu.NavItem to={"/overview/actions"}>
                        Actions
                    </AsideMenu.NavItem>
                </Permission>
                <Permission permission={Permissions.BANKS}>
                    <AsideMenu.NavItem to={"/overview/banks"}>
                        Banks
                    </AsideMenu.NavItem>
                </Permission>
                <Permission permission={Permissions.MIGRATIONS}>
                    <AsideMenu.NavItem to={"/overview/migrations"}>
                        Migrations
                    </AsideMenu.NavItem>
                </Permission>
                <Permission permission={Permissions.SETTINGS}>
                    <AsideMenu.NavItem to={"/overview/settings"}>
                        Settings
                    </AsideMenu.NavItem>
                </Permission>
                {/* <Permission permission={Permissions.SAFE_LOCK}>
                    <AsideMenu.NavItem to={"/overview/safeLocks"}>
                        SafeLocks
                    </AsideMenu.NavItem>
                </Permission> */}
                <Permission permission={Permissions.SAFE_LOCK}>
                    <AsideMenu.NavItem to={"/overview/safeplans"}>
                        Earn
                    </AsideMenu.NavItem>
                </Permission>
                <Permission permission={Permissions.ORDERS}>
                    <AsideMenu.NavItem to={"/overview/balance"}>
                        Balance
                    </AsideMenu.NavItem>
                </Permission>
            </AsideMenu>
            <Section>
                <Suspense fallback={<LayoutSplashScreen />}>
                    <Switch>
                        <ContentRoute exact path="/overview" component={Overview} />
                        <ContentRoute path="/overview/admins" permission="admins" component={Admins} />
                        <ContentRoute path="/overview/actions" permission={Permissions.ACTIONS} component={Actions} />
                        <ContentRoute path="/overview/banks" permission={Permissions.BANKS}
                            component={BankManagement} />
                        <ContentRoute path="/overview/migrations" permission={Permissions.MIGRATIONS}
                            component={Migrations} />
                        <ContentRoute path="/overview/settings" permission={Permissions.SETTINGS} component={Settings} />
                        <ContentRoute path="/overview/safeLocks" permission={Permissions.SAFE_LOCK} component={SafeLockManagement} />
                        <ContentRoute path="/overview/safeplans" permission={Permissions.SAFE_LOCK} component={Plans} />
                        <ContentRoute path="/overview/balance" permission={Permissions.ORDERS} component={Balance} />
                        <Redirect to="/overview"/>
                    </Switch>
                </Suspense>
            </Section>
        </>

    );
}
